const options = [
  {
    label: "Amazon (Electricals only)",
    value: "Amazon (Electricals only)",
  },
  {
    label: "AO",
    value: "AO",
  },
  {
    label: "Apple",
    value: "Apple",
  },
  {
    label: "Argos",
    value: "Argos",
  },
  {
    label: "ASOS (excluding Beauty)",
    value: "ASOS (excluding Beauty)",
  },
  {
    label: "Boots",
    value: "Boots",
  },
  {
    label: "Currys",
    value: "Currys",
  },
  {
    label: "Dreams",
    value: "Dreams",
  },
  {
    label: "Dunelm",
    value: "Dunelm",
  },
  {
    label: "The Entertainer",
    value: "The Entertainer",
  },
  {
    label: "Fenwick",
    value: "Fenwick",
  },
  {
    label: "Flannels",
    value: "Flannels",
  },
  {
    label: "Furniture Village",
    value: "Furniture Village",
  },
  {
    label: "Harrods",
    value: "Harrods",
  },
  {
    label: "Harvey Nichols",
    value: "Harvey Nichols",
  },
  {
    label: "Heal’s",
    value: "Heal’s",
  },
  {
    label: "House of Fraser",
    value: "House of Fraser",
  },
  {
    label: "John Lewis",
    value: "John Lewis",
  },
  {
    label: "Lakeland",
    value: "Lakeland",
  },
  {
    label: "Mamas and Papas",
    value: "Mamas and Papas",
  },
  {
    label: "Marks and Spencer",
    value: "Marks and Spencer",
  },
  {
    label: "Next",
    value: "Next",
  },
  {
    label: "Richer Sounds",
    value: "Richer Sounds",
  },
  {
    label: "Selfridges",
    value: "Selfridges",
  },
  {
    label: "Smyths",
    value: "Smyths",
  },
  {
    label: "Space NK",
    value: "Space NK",
  },
];

export default options;
